import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { IArbetsorderProduktPrimaryKey } from "./ArbetsorderProduktBaseCommand";
export abstract class ArbetsorderProduktinstruktionBaseCommand extends BasicCommand<ArbetsorderProduktinstruktionBaseCommand> {
    handelssortimentId: number;
    produktId: number;
    arbetsorderId: number;
    produktinstruktionId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "ArbetsorderProduktinstruktion";
    get primaryKey(): IArbetsorderProduktinstruktionPrimaryKey {
        return {
            arbetsorderId: this.arbetsorderId,
            handelssortimentId: this.handelssortimentId,
            produktId: this.produktId,
            produktinstruktionId: this.produktinstruktionId
        };
    }

    constructor($type, commandType) {
        super($type, ArbetsorderProduktinstruktionBaseCommand.$groupKey, commandType);
    }
}

export interface IArbetsorderProduktinstruktionPrimaryKey extends IArbetsorderProduktPrimaryKey {
    produktinstruktionId: number;
}
